import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const DeleteConfirmModal = ({ visible, onCancel, onConfirm, signData, loading }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <ExclamationCircleOutlined style={{ color: '#ff4d4f', fontSize: '20px' }} />
          <span>Conferma Eliminazione</span>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          Annulla
        </Button>,
        <Button
          key="delete"
          type="primary"
          danger
          onClick={onConfirm}
          loading={loading}
        >
          Elimina
        </Button>,
      ]}
      centered
      width={450}
    >
      <div style={{ padding: '20px 0' }}>
        <p style={{ fontSize: '16px', marginBottom: '20px' }}>
          Sei sicuro di voler eliminare questo segnale?
        </p>
        {signData && (
          <div style={{ backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px' }}>
            <div style={{ marginBottom: '10px' }}>
              <strong>Tipo:</strong> {signData.type?.replace('-', ' ')}
            </div>
            {signData.description && (
              <div style={{ marginBottom: '10px' }}>
                <strong>Descrizione:</strong> {signData.description}
              </div>
            )}
            <div>
              <strong>Coordinate:</strong> {signData.lat?.toFixed(6)}, {signData.lng?.toFixed(6)}
            </div>
          </div>
        )}
        <p style={{ color: '#ff4d4f', marginTop: '20px', fontWeight: 500 }}>
          Questa azione non può essere annullata.
        </p>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;